exports.modelList = [
  "textattack/albert-base-v2-imdb",
  "textattack/albert-base-v2-rotten-tomatoes",
  "textattack/albert-base-v2-yelp-polarity",
  "textattack/bert-base-uncased-rotten-tomatoes",
  "textattack/bert-base-uncased-SST-2",
  "textattack/distilbert-base-uncased-imdb",
  "textattack/roberta-base-imdb",
  "textattack/roberta-base-SST-2"
]